/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cc_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What contrast ratio do I need?`)
};

const es_cc_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué ratio de contraste necesito?`)
};

const de_cc_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welches Kontrastverhältnis benötige ich?`)
};

const nl_cc_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welke contrastverhouding heb ik nodig?`)
};

const fr_cc_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De quel ratio de contraste ai-je besoin ?`)
};

const it_cc_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Di quale rapporto di contrasto ho bisogno?`)
};

const pt_br2_cc_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual taxa de contraste eu preciso?`)
};

const pt_cc_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De que rácio de contraste preciso?`)
};

const ja_cc_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`必要なコントラスト比はどのくらいですか?`)
};

const zh_cc_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我需要多高的对比度？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cc_faq_q1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cc_faq_q1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cc_faq_q1", locale)
	if (locale === "en") return en_cc_faq_q1(inputs)
	if (locale === "es") return es_cc_faq_q1(inputs)
	if (locale === "de") return de_cc_faq_q1(inputs)
	if (locale === "nl") return nl_cc_faq_q1(inputs)
	if (locale === "fr") return fr_cc_faq_q1(inputs)
	if (locale === "it") return it_cc_faq_q1(inputs)
	if (locale === "pt-BR") return pt_br2_cc_faq_q1(inputs)
	if (locale === "pt") return pt_cc_faq_q1(inputs)
	if (locale === "ja") return ja_cc_faq_q1(inputs)
	return zh_cc_faq_q1(inputs)
};